import $ from 'jquery';

const nav = () => {
  const toggle = $('.js-nav-toggle');

  if (toggle.length) {
    const body = $('body');
    toggle.on('click', ev => {
      ev.preventDefault();
      toggle.toggleClass('is-active');
      body.toggleClass('nav-open');
    });
  }
};
export default nav;



// WEBPACK FOOTER //
// ./src/scripts/modules/nav.js